/* eslint no-lone-blocks: "error" */

'use strict';
/* global L */

{
    // const window.minimalZoomLevel = 18;

    let theMap = null;
    let theMarker = null;

    // eslint-disable-next-line no-unused-vars
    function coachPvMapInit(map, options, noClick) {
        theMap = map;

        const hybrid = L.gridLayer.googleMutant(
            {
                type: 'hybrid', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
            }
        );

        const roadmap = L.gridLayer.googleMutant(
            {
                type: 'roadmap', // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
            }
        );

        const osm = L.tileLayer(
            'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
        );

        const baseLayer = L.layerGroup([hybrid]);
        map.addLayer(baseLayer);

        const baseMaps = {
            'Vue OpenStreepMap': osm,
            'Vue satellite': hybrid,
            'Vue google map': roadmap,
        };

        L.control.locate().addTo(theMap);
        L.control.layers({ OpenStreetMap: baseLayer }, baseMaps).addTo(map);

        if (noClick === undefined) {
            theMap.on('click', onCoachPvMapClick);
        }
        window.coachMap = theMap;
        window.coachMap.roofs = [];
        window.coachMap.clickHandler = undefined;
    }

    function setClickHandler(f) {
        window.coachMap.clickHandler = f;
    }

    function onCoachPvMapClick(e) {
        // if (theMap.getZoom() < window.minimalZoomLevel) {
        //     return;
        // }

        showTheMarker(e.latlng);
        updateHiddenFields(e.latlng);
        showButton(e.latlng);
        if (window.coachMap.clickHandler !== undefined) {
            window.coachMap.clickHandler();
        }
    }

    function getMarker() {
        const myIcon = L.icon({
            iconUrl: '/static/imgs/mps_map_marker.png',
            shadowUrl: '/static/imgs/mps_map_marker_shadow.png',

            iconSize: [28, 41], // size of the icon
            shadowSize: [21, 20], // size of the shadow
            iconAnchor: [14, 40], // point of the icon which will correspond to marker's location
            shadowAnchor: [1, 20], // the same for the shadow

            // popupAnchor: [1, -34],
            // shadowSize: [41, 41],
            // shadowUrl: '/static/leaflet/images/marker-shadow.png',
            // shadowAnchor: [12, 41],
        });
        return myIcon;
    }

    function showTheMarker(latlng) {
        if (theMarker === null) {
            theMarker = L.marker(latlng, { icon: getMarker() }).addTo(theMap);
        } else {
            theMarker.setLatLng(latlng);
        }
    }

    function addAMarker(latlng) {
        L.marker(latlng, { icon: getMarker() }).addTo(theMap);
    }

    function centerTheMap(latlng) {
        theMap.setView(latlng, 19);
        // theMap.flyTo(latlng, 19);
    }

    function updateHiddenFields(latlng) {
        document.getElementById('positionLat').value = latlng.lat;
        document.getElementById('positionLng').value = latlng.lng;
    }

    function showButton(latlng) {
        // document.getElementById('next-button-step-2').style.display = 'block';
    }

    function getLatLngAndCenterMap() {
        const latlngArray = JSON.parse(
            document.getElementById('id_ban_address').value
        ).geometry.coordinates;
        const latlng = { lat: latlngArray[1], lng: latlngArray[0] };
        centerTheMap(latlng);
    }

    function setAddress() {
        let address = '';
        try {
            address = JSON.parse(
                document.getElementById('id_ban_address').value
            ).properties.label;
        } catch (error) {
            return;
        } finally {
            document.getElementById('positionAddress').value = address;
        }
    }

    function goStep1() {
        document.getElementById('step-1').style.display = 'block';
        document.getElementById('map-selection').style.display = 'none';
    }

    function goRoofSelectionOnMap() {
        const step2 = document.getElementById('map-selection');
        step2.style.display = 'block';
        step2.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        setAddress();
        theMap.invalidateSize();
        getLatLngAndCenterMap();

        function clickHandler() {
            document.getElementById('get-roof-segments').click();
        }
        window.setClickHandler(clickHandler);
    }

    function goStep2OnLoad(lat, lng, address) {
        // document.getElementById('step-1').style.display = 'none';
        document.getElementById('step-2').style.display = 'block';
        const latlng = { lat: lat, lng: lng };
        theMap.invalidateSize();

        theMap.setView(latlng, 19);

        showTheMarker(latlng);
        updateHiddenFields(latlng, address);
        showButton(latlng);

        if (address) {
            document.getElementById('address').innerText = address;
        }
    }

    function hideRoofSelectionError() {
        document.getElementById('roof-selection-error').style.display = 'none';
        document.getElementById('roof-selection').style.display = 'block';
        document.getElementById('roof-selection').innerHTML = '';
    }

    function noRoofFound() {
        document.getElementById('roof-selection').style.display = 'none';
        document.getElementById('roof-selection-error').style.display = 'block';
    }

    document.addEventListener('DOMContentLoaded', () => {
        goStep1();
    });

    window.minimalZoomLevel = 18;
    window.coachPvMapInit = coachPvMapInit;
    window.onCoachPvMapClick = onCoachPvMapClick;
    window.getMarker = getMarker;
    window.showTheMarker = showTheMarker;
    window.addAMarker = addAMarker;
    window.centerTheMap = centerTheMap;
    window.updateHiddenFields = updateHiddenFields;
    window.showButton = showButton;
    window.setAddress = setAddress;
    window.getLatLngAndCenterMap = getLatLngAndCenterMap;
    window.goStep1 = goStep1;
    window.goRoofSelectionOnMap = goRoofSelectionOnMap;
    window.goStep2OnLoad = goStep2OnLoad;
    window.setClickHandler = setClickHandler;
    window.noRoofFound = noRoofFound;
    window.hideRoofSelectionError = hideRoofSelectionError;
}
